"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = afterSeempleInit;

// Seemple initializer
function afterSeempleInit() {
  this.nodes = {};
  this.$nodes = {};
}
//# sourceMappingURL=_afterinit.js.map